	document.addEventListener('click', function (e) {
		e = e || window.event;
		var target = e.target || e.srcElement;

		// e.preventDefault();

		if (target.hasAttribute('data-toggle') && target.getAttribute('data-toggle') == 'Notmodal') {
          
			if (target.hasAttribute('data-target')) {
				var m_ID = target.getAttribute('data-target');
              
				document.getElementById(m_ID).classList.add('Not-open');
			}
		}

		// Not-close Notmodal window with 'data-dismiss' attribute or when the backdrop is clicked
		if ((target.hasAttribute('data-dismiss') && target.getAttribute('data-dismiss') == 'Notmodal') ||
			target.classList.contains('Notmodal')) {
			var Notmodal = document.querySelector('[class="Notmodal Not-open"]');
			Notmodal.classList.remove('Not-open');
		}
	}, false);